import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const formatDate = (date: string | undefined): string => {
  if (!date) return ''
  return dayjs(date).format('DD/MM/YYYY')
}

export const formatDateTime = (dateTime: string | undefined): string => {
  if (!dateTime) return ''
  return dayjs.utc(dateTime).local().format('DD/MM/YYYY HH:mm')
}
